__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "template";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tiptap/extension-color", "3.19.0", () => (Promise.all([__webpack_require__.e(551), __webpack_require__.e(911)]).then(() => (() => (__webpack_require__(5911))))));
			register("@tiptap/extension-link", "3.19.0", () => (Promise.all([__webpack_require__.e(903), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(7759))))));
			register("@tiptap/extension-text-style", "3.19.0", () => (Promise.all([__webpack_require__.e(903), __webpack_require__.e(975)]).then(() => (() => (__webpack_require__(2975))))));
			register("@tiptap/extension-underline", "3.19.0", () => (Promise.all([__webpack_require__.e(903), __webpack_require__.e(858)]).then(() => (() => (__webpack_require__(6858))))));
			register("@tiptap/react", "3.19.0", () => (Promise.all([__webpack_require__.e(903), __webpack_require__.e(618), __webpack_require__.e(416), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(4618))))));
			register("@tiptap/starter-kit", "3.19.0", () => (Promise.all([__webpack_require__.e(903), __webpack_require__.e(771), __webpack_require__.e(754)]).then(() => (() => (__webpack_require__(3771))))));
			register("axios", "0.21.1", () => (__webpack_require__.e(868).then(() => (() => (__webpack_require__(2868))))));
			register("peerjs", "1.3.1", () => (Promise.all([__webpack_require__.e(762), __webpack_require__.e(784)]).then(() => (() => (__webpack_require__(5762))))));
			register("react-alert-template-basic", "1.0.2", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(323)]).then(() => (() => (__webpack_require__(2323))))));
			register("react-alert", "7.0.3", () => (Promise.all([__webpack_require__.e(220), __webpack_require__.e(416), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(5220))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(3961))))));
			register("react-file-viewer", "1.2.1", () => (Promise.all([__webpack_require__.e(904), __webpack_require__.e(416), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(1904))))));
			register("react-redux", "7.1.3", () => (Promise.all([__webpack_require__.e(984), __webpack_require__.e(416), __webpack_require__.e(51), __webpack_require__.e(592)]).then(() => (() => (__webpack_require__(2984))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(878), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(5878))))));
			register("react", "18.2.0", () => (__webpack_require__.e(526).then(() => (() => (__webpack_require__(9526))))));
			register("redux", "4.0.5", () => (__webpack_require__.e(670).then(() => (() => (__webpack_require__(7670))))));
			register("socket.io-client", "4.4.0", () => (__webpack_require__.e(740).then(() => (() => (__webpack_require__(8740))))));
			register("universal-cookie", "8.1.2", () => (__webpack_require__.e(59).then(() => (() => (__webpack_require__(3059))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};